import { Descendant, Element as SlateElement } from 'slate';

import { ETagValue, TAG_REG } from './constants';
import { CustomDescendant, CustomElement, CustomText } from './types';
export const deserialize = (text: string): CustomDescendant[] => {
  const children: (CustomText | CustomElement)[] = [];
  let currentText = '';

  const addText = () => {
    if (currentText) {
      children.push({ text: currentText });
      currentText = '';
    }
  };

  // 使用正则表达式分割文本，保留分隔符
  const parts = text.split(TAG_REG);

  parts.forEach((part) => {
    if (part === ETagValue.NPC || part === ETagValue.USER) {
      addText();
      children.push({
        type: 'mention',
        tag: { value: part },
        children: [{ text: '' }],
      });
      // 在mention标签后添加空字符，保证光标正常定位
      children.push({ text: '' });
    } else if (part) {
      currentText += part;
    }
  });

  addText();

  // 如果 children 为空，添加一个空的文本节点
  if (children.length === 0) {
    children.push({ text: '' });
  }

  return [
    {
      type: 'paragraph',
      children,
    },
  ];
};

export const serialize = (nodes: Descendant[]): string => {
  return nodes
    .map((node) => {
      if (SlateElement.isElement(node)) {
        if (node.type === 'mention' && node.tag) {
          return node.tag.value;
        }
        return node.children.map((n) => serialize([n])).join('');
      }
      return node.text;
    })
    .join('');
};
